import React from "react"

export const PaperclipIcon = ({ size = 1, color = "#034055" }) => {
  return (
    <svg
      width={28 * size}
      height={28 * size}
      viewBox="0 0 28 28"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m12.333 23.726 10.41-10.41a4 4 0 0 0 0-5.656l-2.166-2.166a4 4 0 0 0-5.657 0L4.314 16.101a3 3 0 0 0 0 4.243l1.12 1.12a3 3 0 0 0 4.242 0L19.9 11.238a1 1 0 0 0 0-1.414l-1.544-1.544a1 1 0 0 0-1.414 0l-6.316 6.317"
        stroke={color}
        strokeWidth="2.5"
        fill="none"
        fillRule="evenodd"
      />
    </svg>
  )
}
